import { render, staticRenderFns } from "./colaboradores.vue?vue&type=template&id=344eec78&scoped=true"
import script from "./colaboradores.vue?vue&type=script&lang=js"
export * from "./colaboradores.vue?vue&type=script&lang=js"
import style0 from "./colaboradores.vue?vue&type=style&index=0&id=344eec78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344eec78",
  null
  
)

export default component.exports